/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import { motion } from 'framer-motion';
import { X, Users, ArrowRight } from 'lucide-react';

const LoginModal = ({ isOpen, onClose, onLogin }) => {
  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="bg-white rounded-2xl p-6 sm:p-8 max-w-md w-full shadow-xl"
      >
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-2xl font-bold text-slate-900">Login Required</h3>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="text-center mb-6">
          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Users className="w-10 h-10 text-blue-600" />
          </div>
          <p className="text-slate-700 mb-2">
            Please login to confirm your booking
          </p>
          <p className="text-sm text-slate-500">
            Your booking details have been saved and will be restored after login.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={onLogin}
            className="w-full bg-blue-600 text-white py-3.5 font-semibold rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center"
          >
            Login to Continue
            <ArrowRight className="w-4 h-4 ml-2" />
          </button>

          <button
            onClick={onClose}
            className="w-full bg-slate-100 text-slate-700 py-3.5 font-semibold rounded-lg hover:bg-slate-200 transition-colors"
          >
            Cancel
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default LoginModal;